<template>
  <div class="sc-message">
    <div class="sc-message--content" :class="[message.direction]">
      <slot name="user-avatar" :message="message" :user="user">
        <div
          :title="user.name"
          class="sc-message--avatar"
          :style="{
            backgroundImage: `url(${user.imageUrl || icons.chatIcon})`
          }"
        ></div>
      </slot>
      <div class="sc-message--wrapper" @click="handleTime">
        <text-message v-if="message.data && 'text' in message.data" :message="message" />
        <file-message v-if="message.type === 'file'" :message="message" />
        <geolocation-message v-if="message.type === 'location'" :message="message" />
        <list-message v-if="message.type === 'list'" :messageList="message" />
        <carousel-message v-if="message.type === 'carousel'" :messageCarousel="message" />
        <buttons-message v-if="message.type === 'buttons'" :message="message" />
        <transition name="fade">
          <div
            :style="{ color: colors.messageTime.text }"
            v-if="isTimeVisible"
            class="sc-message--time"
          >{{ fromNow(message.createdAt) }}</div>
        </transition>
        <message-status v-if="message.direction === 'sent'" :message="message" />
      </div>
    </div>
  </div>
</template>

<script>
import TextMessage from "./messages/TextMessage.vue";
import FileMessage from "./messages/FileMessage.vue";
import ButtonsMessage from "./messages/ButtonsMessage.vue";
import GeolocationMessage from "./messages/GeolocationMessage.vue";
import ListMessage from "./messages/ListMessage.vue";
import CarouselMessage from "./messages/CarouselMessage.vue";
import MessageStatus from "./MessageStatus.vue";
import dayjs from "dayjs";
import relativeTime from 'dayjs/plugin/relativeTime';

import 'dayjs/locale/en';
import 'dayjs/locale/fr';

dayjs.extend(relativeTime);

export default {
  name: "Message",
  inject: {
    chat: {
      type: Object
    },
    colors: {
      type: Object
    },
    icons: {
      type: Object
    }
  },
  data() {
    return {
      isTimeVisible: false,
    };
  },
  components: {
    TextMessage,
    FileMessage,
    ButtonsMessage,
    GeolocationMessage,
    MessageStatus,
    ListMessage,
    CarouselMessage
  },
  props: {
    message: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleTime() {
      this.isTimeVisible = !this.isTimeVisible;
    },
    fromNow(time) {
      return dayjs(time, { locale: this.$i18n.locale }).fromNow();
    }
  },
  computed: {
    user() {
      return (
        this.chat.participants.find(
          participant => participant.id === this.message.author
        ) || { id: "me", name: "Anon", imageUrl: this.icons.chatIcon }
      );
    }
  }
};
</script>
<style lang="scss">
.sc-message--wrapper {
  max-width: calc(100% - 60px);
  width: auto;
}
.sc-message {
  margin: auto;
  padding: 0 .5rem 0 .5rem;
  display: flex;

  &:first-child {
    margin-top: 50%;
  }

  .sc-message--edited {
    opacity: 0.7;
    word-wrap: normal;
    font-size: xx-small;
    text-align: center;
  }
}

.sc-message--content {
  width: 100%;
  display: flex;
  position: relative;
  margin-bottom: 1.5rem;
}

.sc-message--content.sent {
  justify-content: flex-end;
}

.sc-message--content.sent .sc-message--avatar {
  display: none;
}

.sc-message--avatar {
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: center;
  min-width: 30px;
  min-height: 30px;
  border-radius: 50%;
  align-self: center;
  margin-right: 15px;
  margin-top: auto;
  transform: translateY(-10%);
}

.sc-message--meta {
  font-size: xx-small;
  margin-bottom: 0px;
  color: white;
  text-align: center;
}

@media (max-width: 450px) {
  .sc-message {
    width: 80%;
  }
}

.sc-message--text {
  padding: 5px 20px;
  border-radius: 6px;
  font-weight: 300;
  font-size: 1rem;
  max-width: 190px;
  line-height: 1.4;
  position: relative;
  -webkit-font-smoothing: subpixel-antialiased;
  .sc-message--text-body {
    .sc-message--text-content {
      white-space: pre-wrap;
    }
  }
}
.sc-message--content.sent .sc-message--text {
  color: white;
  background-color: #4e8cff;
  word-wrap: break-word;
}

.sc-message--text code {
  font-family: "Courier New", Courier, monospace !important;
}

.sc-message--content.received .sc-message--text {
  color: #263238;
  background-color: #f4f7f9;
}
.sc-message--time {
  font-size: .75rem;
  display: block;
  position: absolute;
  bottom: -.75rem;
  transition-duration: 5s;
}
.sc-message--content.sent .sc-message--time {
  right: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
